import React from "react";
import { Alert, Button, CircularProgress, Stack } from "@mui/material";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import {
  formatNextBillingRunLabel,
  resolveBillingVerificationStatus,
} from "../../utils/nextRedemptionBillingRun";

export default function RedemptionVerificationPanel({
  redemption,
  loading,
  onApprove,
  onCancelApproval,
  onRetryBilling,
}) {
  const status = resolveBillingVerificationStatus(redemption);
  const nextRun = formatNextBillingRunLabel();

  if (status === "verified") {
    return (
      <Alert severity="success" icon={<CheckBoxIcon />} sx={{ maxWidth: 580 }}>
        Verified — bill in Xero
        {redemption.invoiceID ? ` (${redemption.invoiceID})` : ""}
      </Alert>
    );
  }

  if (status === "xero_pending") {
    return (
      <Stack spacing={1} sx={{ maxWidth: 580 }}>
        <Alert severity="warning">
          Approved — bill pending next run (~{nextRun}). Merchant email sends after the bill is
          created in Xero.
        </Alert>
        <Button
          variant="text"
          color="inherit"
          disabled={loading}
          onClick={onCancelApproval}
          startIcon={loading ? <CircularProgress size={18} /> : null}
        >
          Cancel approval
        </Button>
      </Stack>
    );
  }

  if (status === "billing_failed") {
    return (
      <Stack spacing={1} sx={{ maxWidth: 580 }}>
        <Alert severity="error">
          Billing failed
          {redemption.xeroBillLastError ? `: ${redemption.xeroBillLastError}` : ""}
        </Alert>
        <Stack direction="row" spacing={1}>
          <Button
            variant="contained"
            disabled={loading}
            onClick={onRetryBilling}
            startIcon={loading ? <CircularProgress size={18} color="inherit" /> : null}
          >
            Retry billing
          </Button>
          <Button variant="text" disabled={loading} onClick={onCancelApproval}>
            Cancel approval
          </Button>
        </Stack>
      </Stack>
    );
  }

  return (
    <Stack spacing={1} sx={{ maxWidth: 580 }}>
      <Alert severity="info">Not approved</Alert>
      <Button
        variant="contained"
        disabled={loading}
        onClick={onApprove}
        startIcon={loading ? <CircularProgress size={18} color="inherit" /> : null}
      >
        Approve redemption
      </Button>
    </Stack>
  );
}
